import React, { useContext, useState, useEffect } from "react";
import ListLines from "components/ListLines/ListLines";
import fish1 from "../assets/images/bitamin.png";
import vegetable from "../assets/images/vegetable.png"
import { values } from "lodash";
import { connection } from "utils/apiConnection.ts";
export default function ParentListLines() {
  const [listLines, setListLines] = useState([]);
  useEffect(()=>{
    connection("api/getlines").then((data)=>{
      setListLines(data.lines);
    })
  },[])
  return (
    <div>
          <div>
            <ListLines
              listLines={listLines}
              setListLines={setListLines}
              vegetable={vegetable}
            ></ListLines>
          </div>
    </div>
  );
}
